<template>
    <component
        :is="selectedLayout"
        :bundle="myBundleData"
        :coursesVisibility="coursesVisibility"
        :initialPriceVisibility="initialPriceVisibility"
        :finalPriceVisibility="finalPriceVisibility"
        :discountPercentageVisibility="discountPercentageVisibility"
        :savingsVisibility="savingsVisibility"
        :panelStyleClass="panelStyleClass"
    >
    </component>
</template>

<script>
    import {mapState} from "vuex";
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";
    import BundleDataLayout1 from "../../../author/pagesbuilder/templates/cards/BundleDataLayout1";
    import BundleDataLayout2 from "../../../author/pagesbuilder/templates/cards/BundleDataLayout2";
    import BundleDataLayout3 from "../../../author/pagesbuilder/templates/cards/BundleDataLayout3";

    export default {
        name: "BundleDataComponent",
        mixins: [
          AnimationsMixin,
        ],
        data () {
            return {
                componentType: "bundle-data",
                rendersWithVue: true
            }
        },
        computed: {
            ...mapState('products',[
                'bundles'
            ]),
            availablePanelStyleOptions () {
                return [
                    {
                        label: "None",
                        value: "none",
                        cssClass: "",
                        forSectionTemplates: [
                            "tpl-bundle-cta-1",
                            "tpl-bundle-cta-2",
                            "tpl-bundle-cta-3",
                            "tpl-bundle-data-2",
                            "tpl-bundle-data-3",
                        ],
                    },
                    {
                        label: "Body Bg",
                        value: "body-bg",
                        cssClass: "lw-body-bg",
                        forSectionTemplates: [
                            "tpl-bundle-hero-4",
                        ],
                    },
                    {
                        label: "Light",
                        value: "light",
                        cssClass: "lw-light-bg",
                        forSectionTemplates: [

                        ],
                    },
                    {
                        label: "Dark",
                        value: "dark",
                        cssClass: "lw-dark-bg",
                        forSectionTemplates: [

                        ],
                    },
                    {
                        label: "Brand",
                        value: "brand",
                        cssClass: "lw-brand-bg",
                        forSectionTemplates: [
                            
                        ],
                    },
                    {
                        label: "Accent1",
                        value: "accent1",
                        cssClass: "lw-brand-accent1-bg",
                        forSectionTemplates: [
                            "tpl-bundle-data-1",
                        ],
                    },
                ];
            },
            availableBundleDataTemplates () {
                return [
                    {
                        templateFilename : "BundleDataLayout1",
                        forSectionTemplates: [
                            "tpl-bundle-hero-4",
                            "tpl-bundle-cta-1",
                            "tpl-bundle-cta-2",
                        ]
                    },
                    {
                        templateFilename : "BundleDataLayout2",
                        forSectionTemplates: [
                            "tpl-bundle-cta-3",
                            "tpl-bundle-data-1",
                            "tpl-bundle-data-3",
                        ]
                    },
                    {
                        templateFilename : "BundleDataLayout3",
                        forSectionTemplates: [
                            "tpl-bundle-data-2",
                        ]
                    },
                ];
            },
            currentSectionTemplateId () {
                let sectionState = this.findNodeState(this.sectionId);
                return sectionState ? sectionState.sectionTemplateId : '';
            },
            defaultCoursesVisibility () {
                const templatesToHide = [
                    "tpl-bundle-cta-3",
                    "tpl-bundle-data-2",
                ];
                return templatesToHide.indexOf(this.currentSectionTemplateId) < 0;
            },
            defaultInitialPriceVisibility () {
                const templatesToHide = [
                    "tpl-bundle-hero-4",
                    "tpl-bundle-cta-1",
                    "tpl-bundle-cta-2",
                    "tpl-bundle-cta-3",
                    "tpl-bundle-data-1",
                    "tpl-bundle-data-3",
                ];
                return templatesToHide.indexOf(this.currentSectionTemplateId) < 0;
            },
            defaultFinalPriceVisibility () {
                const templatesToHide = [
                    "tpl-bundle-hero-4",
                    "tpl-bundle-cta-1",
                    "tpl-bundle-cta-2",
                    "tpl-bundle-cta-3",
                    "tpl-bundle-data-1",
                    "tpl-bundle-data-3",
                ];
                return templatesToHide.indexOf(this.currentSectionTemplateId) < 0;
            },
            defaultDiscountPercentageVisibility () {
                const templatesToHide = [];
                return templatesToHide.indexOf(this.currentSectionTemplateId) < 0;
            },
            defaultSavingsVisibility () {
                const templatesToHide = [
                    "tpl-bundle-cta-3",
                ];
                return templatesToHide.indexOf(this.currentSectionTemplateId) < 0;
            },
            defaultPanelStyleClass () {
                let foundStyleOption = this.availablePanelStyleOptions.find(template => template.forSectionTemplates.includes(this.currentSectionTemplateId));
                return foundStyleOption ? foundStyleOption.cssClass : this.availablePanelStyleOptions[0].cssClass;
            },
            defaultTemplate () {
                let foundTemplate = this.availableBundleDataTemplates.find(template => template.forSectionTemplates.includes(this.currentSectionTemplateId));
                return foundTemplate ? foundTemplate.templateFilename : this.availableBundleDataTemplates[0].templateFilename;
            },
            getDefaultDataStructure () {
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    template: this.defaultTemplate,
                    styles: null,

                    coursesVisibility: this.defaultCoursesVisibility,
                    initialPriceVisibility: this.defaultInitialPriceVisibility,
                    finalPriceVisibility: this.defaultFinalPriceVisibility,
                    discountPercentageVisibility: this.defaultDiscountPercentageVisibility,
                    savingsVisibility: this.defaultSavingsVisibility,

                    panelStyleClass: this.defaultPanelStyleClass,
                    itemVisibilitySettings: null
                }
            },
            panelStyleClass () {
                return this.myData.panelStyleClass;
            },
            coursesVisibility () {
                return this.myData.coursesVisibility;
            },
            initialPriceVisibility () {
                return this.myData.initialPriceVisibility;
            },
            finalPriceVisibility () {
                return this.myData.finalPriceVisibility;
            },
            discountPercentageVisibility () {
                return this.myData.discountPercentageVisibility;
            },
            savingsVisibility () {
                return this.myData.savingsVisibility;
            },
            selectedBundleId () {
                if (this.componentData.selectedBundleId) {
                    return this.componentData.selectedBundleId;
                }

                if (this.hasContext('bundle-overview-section')) {
                    const sectionNodeState = this.findNodeState(this.sectionId);
                    return sectionNodeState ? sectionNodeState.getSelectedBundle() : "";
                }

                if (this.isPageContext('bundle') && this.pageContext.params && this.bundles.filter( bundle => bundle.titleId === this.pageContext.params.slug).length ) {
                    return this.pageContext.params.slug;
                }

                return "";
            },
            myBundleData () {
                const bundleData = this.bundles.find(bundle => bundle.titleId === this.selectedBundleId);
                return bundleData || {};
            },
            selectedLayout () {
                return this.componentData.template;
            }
        },
        components: {
            BundleDataLayout1,
            BundleDataLayout2,
            BundleDataLayout3,
        }
    }
</script>
